export const version = {
    major: 4,
    minor: 5,
    patch: 4,
};
